import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';

const initialState = {
  user: {
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    userId: "",
    auth: "",
  },
};

export const userSlice = createSlice({
  name: "userStore",
  initialState: () => {
    const tempUser = localStorage["user"];
    if (tempUser) return { user: JSON.parse(tempUser) };
    return initialState;
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
      Cookies.set('userDetails', JSON.stringify(action.payload), { path: '/',  domain: process.env.REACT_APP_COOKIE, expires: 7 });
    },
    resetUser(state) {
      state.user = initialState.user;
      localStorage.removeItem("user");
      Cookies.remove('userDetails', { path: '/', domain: process.env.REACT_APP_COOKIE, secure: true });

    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
